export default __webpack_public_path__ + "static/media/slider_2-sm@1x.81650068.jpg";